import { futureValueOfMonthlySavings } from "web_myplann/Goals/Helpers/futureValueOfMonthlySavings";
import { RETIREMENT_SCENARIOS } from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementScenario } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementScenarios = (
	monthlyContribution: number,
	months: number,
	targetCapital: number,
): RetirementScenario[] =>
	RETIREMENT_SCENARIOS.map(({ key, rate, recommended }) => {
		const total = Math.round(
			futureValueOfMonthlySavings(monthlyContribution, rate, months),
		);
		return {
			key,
			rate,
			total,
			coverage:
				targetCapital > 0 ? Math.round((total / targetCapital) * 100) : 0,
			recommended,
		};
	});
